<template>
    <div class="survey-note-form-resources"
         v-if="planResources && planResources.length">

        <b-card>
            <ul>
                <li v-for="(opt, index) in checkedPlanOptions" :key="index">
                    {{ opt.value }}
                </li>
            </ul>
        </b-card>

    </div>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'

/**
 * Displays a list of checkboxes to select Resources for an individual ReportWidget
 */
export default Vue.extend({
    name: 'SurveyNoteFormResources',
    computed: {
        planResources() {
            if (this.$store.state.patientParticipant.plan) {
                return _.filter(this.$store.state.patientParticipant.plan.planResources, (pr) => {
                    return pr.resource_type == 'plan_of_care_option'
                })
            } else {
                return []
            }
        },
        // planOptions format: {value: 'Physical Therapy', checked: false, resourceKeys: ['SCORE_EXER', ...]
        // (see SurveyNote::initPlanOptions)
        checkedPlanOptions() {
            if (this.$store.state.draftSurveyNote.plan_options) {
                return _.filter(this.$store.state.draftSurveyNote.plan_options, (po) => {
                    // return po.resourceKeys.indexOf(this.scoreName) != -1
                    return po.checked
                })
            } else {
                return []
            }
        },
    },
})
</script>

<style lang="scss">
.survey-note-form-resources {
    .card-body {
        margin: 0 0 -1rem 0 !important;
    }
}
</style>
